export function isGeometryNode(node?: any) {
  return node !== undefined && node !== null && node.isGeometryNode;
}

export function isTreeNode(node?: any) {
  return node !== undefined && node !== null && node.isTreeNode;
}
